var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGame = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26416",
    "data-name": "Group 26416",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46830",
    "data-name": "Path 46830",
    d: "M69.1,62H72.88a1.031,1.031,0,0,1,1.046,1.021v5.054h5.054A1.01,1.01,0,0,1,80,69.1V72.88a1.031,1.031,0,0,1-1.021,1.046H73.925v5.054A1.031,1.031,0,0,1,72.88,80H69.1a1.01,1.01,0,0,1-1.021-1.021V73.925H63.021A1.031,1.031,0,0,1,62,72.88V69.1a1.01,1.01,0,0,1,1.021-1.021h5.054V63.021A1.01,1.01,0,0,1,69.1,62Zm3.037,7.867a1.6,1.6,0,0,0-2.266,2.266,1.6,1.6,0,0,0,2.266-2.266Zm5.7,1.12-1.593-.921v1.842Zm-13.693,0,1.593.921V70.066Zm6.846,6.846.921-1.593H70.066Zm0-13.693-.921,1.593h1.842Z",
    transform: "translate(-62 -62)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGame);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_game.f40dc940cb80c17b0dfcee7feb4de645.svg";